export default __webpack_public_path__ + "static/media/goodDay-running.775f39ba.png";